import {
  Button,
  Stack,
  Typography
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { AnimatedContainer, RootContainer } from "./AISupportChatErrorOverlay.styles";

interface AISupportChatErrorOverlayProps {
  error: string;
  onReset: () => void;
}

const AISupportChatErrorOverlay = ({
  error,
  onReset
}: AISupportChatErrorOverlayProps) => {
  const { t } = useTranslation();

  return (
    <AnimatedContainer in>
      <RootContainer gap={ "20px" }>
        <Stack alignItems="center">
          <Typography sx={ { fontWeight: "bold", textAlign: "center" } }>
            { t("ai_support_chat_session_error") }
          </Typography>
          { error && (
            <Typography sx={ { fontSize: "10px", textAlign: "center" } }>
              { error }
            </Typography>
          ) }
        </Stack>
        <Stack spacing={ 1 }>
          <Button variant={ "contained" } onClick={ onReset }>
            { t("ai_support_chat_restart_session_btn") }
          </Button>
        </Stack>
      </RootContainer>
    </AnimatedContainer>
  );
};

export default AISupportChatErrorOverlay;
